import type {
  UseApiFetch,
  UseApiFetchPromise,
} from '@/contexts/shared/api/constructor/ApiFetcherConstructor.interfaces'
import HttpStatusCode from '@/interfaces/HttpStatusCodes.interfaces'
import store from '@/store'

export const redirectIfUnauthorized = async <T, E>(response: UseApiFetch<T, E>): UseApiFetchPromise<T, E> => {
  if (response.code === HttpStatusCode.UNAUTHORIZED) {
    await store.dispatch('logout')
    document.location.href = '/'
  }

  return response
}
